module.exports = __webpack_public_path__ + "static/media/tournament-lobby-last.b08ec0f1.png";